import { NeedAuthLoadingLazy } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { Route } from 'react-router-dom'

const mapRouterHelper = (routers: AppRouterItem[], prefix?: string) => {
  if (!routers) return null

  return routers.map(({ path, element }) => {
    const fullPath = prefix ? prefix + path : path
    return (
      <Route
        path={fullPath}
        element={<NeedAuthLoadingLazy>{element}</NeedAuthLoadingLazy>}
        key={fullPath}
      />
    )
  })
}

export default mapRouterHelper
